/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacypolicy1Inputs */

const id_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Privasi`)
};

const ms_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar Privasi`)
};

const da_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitik`)
};

const de_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklärung`)
};

const en_us2_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const es_es2_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const es_mx2_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const fil_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patakaran sa Privacy`)
};

const fr_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const it_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla privacy`)
};

const hu_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatvédelmi irányelvek`)
};

const nl_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacybeleid`)
};

const no_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personvernerklæring`)
};

const pl_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności`)
};

const pt_br2_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`política de Privacidade`)
};

const pt_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidade`)
};

const ro_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de confidențialitate`)
};

const fi_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuojakäytäntö`)
};

const sv_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetspolicy`)
};

const vi_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính sách bảo mật`)
};

const tr_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası`)
};

const cs_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásady ochrany osobních údajů`)
};

const bg_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика за поверителност`)
};

const ru_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const uk_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Політика конфіденційності`)
};

const ar_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الخصوصية`)
};

const hi_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोपनीयता नीति`)
};

const th_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายความเป็นส่วนตัว`)
};

const ja_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

const zh_cn2_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const zh_hant1_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱私權政策`)
};

const ko_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보 처리방침`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Privacypolicy1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_privacypolicy1 = /** @type {((inputs?: Footer_Privacypolicy1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacypolicy1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_privacypolicy1(inputs)
	if (locale === "ms") return ms_footer_privacypolicy1(inputs)
	if (locale === "da") return da_footer_privacypolicy1(inputs)
	if (locale === "de") return de_footer_privacypolicy1(inputs)
	if (locale === "en-US") return en_us2_footer_privacypolicy1(inputs)
	if (locale === "es-ES") return es_es2_footer_privacypolicy1(inputs)
	if (locale === "es-MX") return es_mx2_footer_privacypolicy1(inputs)
	if (locale === "fil") return fil_footer_privacypolicy1(inputs)
	if (locale === "fr") return fr_footer_privacypolicy1(inputs)
	if (locale === "it") return it_footer_privacypolicy1(inputs)
	if (locale === "hu") return hu_footer_privacypolicy1(inputs)
	if (locale === "nl") return nl_footer_privacypolicy1(inputs)
	if (locale === "no") return no_footer_privacypolicy1(inputs)
	if (locale === "pl") return pl_footer_privacypolicy1(inputs)
	if (locale === "pt-BR") return pt_br2_footer_privacypolicy1(inputs)
	if (locale === "pt") return pt_footer_privacypolicy1(inputs)
	if (locale === "ro") return ro_footer_privacypolicy1(inputs)
	if (locale === "fi") return fi_footer_privacypolicy1(inputs)
	if (locale === "sv") return sv_footer_privacypolicy1(inputs)
	if (locale === "vi") return vi_footer_privacypolicy1(inputs)
	if (locale === "tr") return tr_footer_privacypolicy1(inputs)
	if (locale === "cs") return cs_footer_privacypolicy1(inputs)
	if (locale === "bg") return bg_footer_privacypolicy1(inputs)
	if (locale === "ru") return ru_footer_privacypolicy1(inputs)
	if (locale === "uk") return uk_footer_privacypolicy1(inputs)
	if (locale === "ar") return ar_footer_privacypolicy1(inputs)
	if (locale === "hi") return hi_footer_privacypolicy1(inputs)
	if (locale === "th") return th_footer_privacypolicy1(inputs)
	if (locale === "ja") return ja_footer_privacypolicy1(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_privacypolicy1(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_privacypolicy1(inputs)
	return ko_footer_privacypolicy1(inputs)
});
export { footer_privacypolicy1 as "footer.privacyPolicy" }